import { Text } from '@user-portal/wikr-components';
import { Trans, useTranslation } from 'react-i18next';

import * as S from './styled';

import { SubscriptionCardPropsType } from './types';

const SubscriptionCard = ({
    title,
    bgColor,
    period,
    price,
    currencySign,
    isDiscountCard,
    oldPrice,
    changeSubscription,
}: SubscriptionCardPropsType) => {
    const { t } = useTranslation();

    return (
        <S.SubscriptionCard>
            <S.SubscriptionCardTitle
                dataLocator={isDiscountCard ? 'unsubscribeDiscount' : undefined}
                medium
                center
                color="surface-main"
                $bgColor={bgColor}
            >
                {title}
            </S.SubscriptionCardTitle>
            <S.SubscriptionCardContent
                data-locator={isDiscountCard ? 'unsubscribeNewPlanBlock' : 'unsubscribeCurrentPlanBlock'}
            >
                <Text type="small-button" center mb={20} dataLocator="unsubscribeCurrentPlan">
                    {t('subscription.discountOfferModal.discountCard.period', {
                        period,
                    })}
                </Text>
                {isDiscountCard && (
                    <S.SubscriptionCardOldPrice
                        dataLocator="unsubscribeOldPrice"
                        type="large-text"
                        center
                        mb={8}
                        medium
                    >
                        {t('subscription.discountOfferModal.discountCard.oldPrice', {
                            currencySign,
                            price: oldPrice,
                            period,
                        })}
                    </S.SubscriptionCardOldPrice>
                )}
                <Text
                    dataLocator={isDiscountCard ? 'unsubscribeNewPlanPrice' : 'unsubscribeCurrentPlanPrice'}
                    type="h2"
                    medium
                    center
                    mb={isDiscountCard ? 20 : 0}
                >
                    <Trans
                        i18nKey="subscription.discountOfferModal.discountCard.pricePeriod"
                        values={{
                            currencySign,
                            price,
                            period,
                        }}
                        components={{
                            span: <S.SubscriptionCardPricePeriod />,
                        }}
                    />
                </Text>
                {isDiscountCard && (
                    <>
                        <Text center mb={20} type="caption">
                            {t('subscription.discountOfferModal.discountCard.description', {
                                period,
                            })}
                        </Text>
                        <S.ChangeButton onClick={changeSubscription} dataLocator="unsubscribeChangePlanButton">
                            {t('subscription.discountOfferModal.btn.changePlan')}
                        </S.ChangeButton>
                    </>
                )}
            </S.SubscriptionCardContent>
        </S.SubscriptionCard>
    );
};

export default SubscriptionCard;
